Ember.Route.reopen({
 activate: function(){
   if( this.get('isLeafRoute') ){
     Pegasus.set('lastLeaf', this.get('routeName') );
   }
   this._super();
 },
 isLeafRoute: function(){
    return Pegasus.Router.router.recognizer.names &&
      Pegasus.Router.router.recognizer.names.hasOwnProperty( this.get('routeName') );
  }.property()
});
